export const urlChangeEventTarget =
	/**
	 * @type {{
	 *      addEventListener(
	 *         type: 'change',
	 *         listener: (event: CustomEvent<{
	 *             type: null | 'popstate' | 'hashchange',
	 *             newURL: string;
	 *             oldURL: string;
	 *         }>)=>{}
	 *     ): void;
	 *      removeEventListener(
	 *         type: 'change',
	 *         listener: (event: CustomEvent<{
	 *             type: null | 'popstate' | 'hashchange',
	 *             newURL: string,
	 *             oldURL: string,
	 *         }>)=>{},
	 *    ): void;
	 * }}
	 */(new EventTarget());

let oldURL = window.location.href;

window.addEventListener('popstate', (event) => {
	check_url_change({type: 'popstate'})
});
window.addEventListener('hashchange', (event) => {
	check_url_change({type: 'hashchange'})
});

/**
 * force check if url updated and send events
 */
function check_url_change(options) {
	const type = options?.type ?? null;
	// console.log({check_url_change:type});
	let newURL = window.location.href;
	if (newURL === oldURL) return;
	urlChangeEventTarget.dispatchEvent(new CustomEvent('change', {
		detail: {
			newURL,
			oldURL,
			type,
		},
	}));
	oldURL = newURL;
}

/**
 * @param {History.state} data
 * @param { string | URL | null | undefined} [url]
 */
export function replaceState(data, url){
	window.history.replaceState({
		...data
	}, '', url);
	check_url_change()
}

/**
 * @param {History.state} data
 * @param { string | URL | null | undefined} [url]
 */
export function pushState(data, url){
	window.history.pushState({
		...data,
	}, '', url);
	check_url_change()
}
